// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BXuj","tabsBox":"styles_tabsBox__1zK4d","createButton":"styles_createButton___-LkU"};